"use client";

import { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import { CcSectionReveal } from "@/components/ui/CcSectionReveal";
import type { BrandingStudioCopy } from "./branding-page-copy";
import styles from "./branding-studio.module.scss";

export function CcBrandingTransformation({ copy }: { copy: BrandingStudioCopy["transform"] }) {
  const [designed, setDesigned] = useState(true);
  return (
    <CcSectionReveal className={`${styles.section} ${styles.transformSection}`} threshold={0.05} data-cc-nav="light" aria-labelledby="branding-transform-title">
      <div className={styles.shell}>
        <header className={styles.sectionHeader}>
          <CcSanjayaEyebrow>{copy.eyebrow}</CcSanjayaEyebrow>
          <h2 id="branding-transform-title">{copy.title}</h2><p>{copy.lead}</p>
        </header>
        <div className={styles.switcher} role="group" aria-label={copy.eyebrow}>
          <button type="button" aria-pressed={!designed} onClick={() => setDesigned(false)}>{copy.before}</button>
          <button type="button" aria-pressed={designed} onClick={() => setDesigned(true)}>{designed && <Check size={16} />}{copy.after}</button>
        </div>
        <div className={styles.transformation} data-designed={designed}>
          <div className={styles.websiteExample}>
            <div className={styles.exampleLabel}><span>{copy.siteLabel}</span><span aria-hidden="true">● ● ●</span></div>
            <div className={styles.websiteNav}><strong><span className={styles.formaMark} aria-hidden="true">✳</span> FORMA</strong><ArrowUpRight size={22} /></div>
            <div className={styles.websiteBody}>
              <div><h3>{designed ? copy.headline : copy.beforeHeadline}</h3><p>{designed ? copy.body : copy.beforeBody}</p><span className={styles.mockCta}>{designed ? copy.cta : copy.beforeCta}<ArrowUpRight size={16} /></span></div>
              <div className={styles.architectureArt} aria-hidden="true"><i /><i /><i /><span>f.</span></div>
            </div>
          </div>
          <div className={styles.applicationExamples}>
            <div className={styles.businessCard}><span className={styles.exampleLabel}>{copy.cardLabel}</span><strong><span className={styles.formaMark} aria-hidden="true">✳</span> FORMA</strong><span>{copy.contact}<ArrowUpRight size={17} /></span></div>
            <div className={styles.socialCard}><span className={styles.exampleLabel}>{copy.postLabel}</span><strong>{copy.post}</strong><span className={styles.socialMark} aria-hidden="true">✳</span><span>FORMA®</span></div>
          </div>
        </div>
        <p className={styles.conceptCaption}>{copy.example}</p>
        <div className={styles.insights}>{copy.insights.map((item, i) => <div key={item.title}><span>0{i + 1}</span><h3>{item.title}</h3><p>{item.text}</p></div>)}</div>
      </div>
    </CcSectionReveal>
  );
}
